import React from 'react'
import { dataAppDatabase, locale } from '../../../index'
import 'react-datepicker/dist/react-datepicker.css'
import firebase from 'firebase'
import PropTypes from 'prop-types'
// import AlertContainer from 'react-alert'
// import { alertOptions } from '../../../resources/utilities'
import FormRenderer from '../../common/FormRenderer/FormRenderer'

export default class PatientData extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      patient: undefined,
      patientKey: undefined,
      loading: ''
    }
    this.saveChanges = this.saveChanges.bind(this)
    this.getConfiguration = this.getConfiguration.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  saveChanges (data, patientKey) {
    this.setState({
      loading: 'cursor-loading'
    })
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(patientKey)
    patientRef.update(data).then(function () {
      // this.msg.success(polyglot.t('staticText.dataSuccessfullyChanged'))
      this.setState({
        loading: ''
      })
    }.bind(this)).catch(function (error) {
      // this.msg.error(polyglot.t('commonFields.undefinedError'))
      this.setState({
        loading: ''
      })
      console.log(error)
    }.bind(this))
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patient = null
    let patientKey = null
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patient = childSnap.val()
          patientKey = childSnap.key
          this.props.setPatientId(childSnap.val().patientNumber)
        }
      })
      if (patient !== null) {
        this.setState({
          patientKey: patientKey,
          patient: patient
        })
      }
    })
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      this.setState({
        patientDataConfig: dataSnapshot.child('patientData').val()
      })
    })
  }

  handleSubmit (data) {
    this.saveChanges(data, this.state.patientKey)
  }

  renderContent () {
    if (this.state.patientDataConfig && this.state.patientKey) {
      return <FormRenderer
        dataKey={this.state.patientDataConfig.key}
        savedData={this.state.patient}
        saveData={this.handleSubmit}
        extraFieldContent={this.state.patientDataConfig.extraFieldContent}
        fields={this.state.patientDataConfig.fields}
        extraFieldEnabled={this.state.patientDataConfig.isExtraFieldEnabled} />
    } else {
      return null
    }
  }

  componentWillMount () {
    this.getPatient(this.props.match.params.patientId)
    this.getConfiguration()
  }

  render () {
    return <div className={`container ${this.state.loading}`}>
      {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
      {this.renderContent()}
    </div>
  }
}

PatientData.propTypes = {
  setPatientId: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/PatientData/PatientData.js